import { Flex } from 'antd';
import styles from '../navbar.module.scss';
import landingGirl from '../../../assets/imgs/landing_girl.webp';
import { Button } from '../../../common';
import { GetStartedArrowIcon, LandingBackgroundArrow, RatingsIcon } from '../../../common/all-icons/custom-icons';

const TopSection = ({ signupRef }) => {
  const handleGetStarted = () => {
    signupRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <Flex className={styles.topWrap} justify="center" align="center">
      <div className={styles.topSection}>
        <div className={styles.topLeftSection}>
          <div className={styles.topLeftCover}>
            <LandingBackgroundArrow
              className={'hide-on-small'}
              style={{ position: 'absolute', right: '-80px', top: '-20px' }}
            />
            <Flex gap={16} align="center">
              <RatingsIcon />
              <div className="h5-semibold">4.8 • Excellent Reviews</div>
            </Flex>
            <div className={styles.heading}>
              Take Control of Your <br className="hide-on-small" /> Health in Just 2 Minutes
            </div>
            <div className={styles.subheading}>Finally, healthcare that actually works for you</div>
          </div>
          <Button
            style={{
              height: '48px',
              paddingInline: '16px',
              width: 'fit-content',
              alignItems: 'center',
            }}
            onClick={handleGetStarted}
            className={'primary-button body-14-semibold'}
          >
            Get Started
            <GetStartedArrowIcon />
          </Button>
        </div>
        <img src={landingGirl} className={styles.girl} />
      </div>
    </Flex>
  );
};

export default TopSection;
